import { ts } from '_core';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.ALPHA_MODEL_TREE_MODELS_GOODNESS_OF_FIT,
    title: 'Tree Model Goodness of Fit',
    helpLabel: '0tnull3lge',
    form: false,
    neededFiles: ['tree_models_goodness_of_fit'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.RANDOM_FOREST_ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.GRADIENT_BOOSTING_ALPHA_MODEL,
    ],
  },
] satisfies ts.types.analysis.WidgetConfig[];
